<script setup></script>
<template>
  <div class="flex items-center justify-center w-full py-8">
    <font-awesome class="fa-fw animate-spin text-sky-700 text-5xl" :icon="['fas', 'spinner-third']" />
  </div>
</template>
